import { ApiBuilder } from "@equidefi/portals/clients";

import { CONFIG } from "../constants/config";

export const ApiInstance = ApiBuilder.buildClient(CONFIG.API_URL);
